import { render, staticRenderFns } from "./hair3.vue?vue&type=template&id=6fe06915&scoped=true&"
import script from "./hair3.vue?vue&type=script&lang=js&"
export * from "./hair3.vue?vue&type=script&lang=js&"
import style0 from "./hair3.vue?vue&type=style&index=0&id=6fe06915&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe06915",
  null
  
)

export default component.exports